import { Component } from '@angular/core'
import { TransifexService } from '../../services/transifex.service'
import { SharedTranslationsService } from '../../services/shared-translations.service'
import { TemplateKeyDirective } from '../../directives/template-key.directive'

@Component({
  selector: 'customer-portal-lib-cpt-templates',
  imports: [TemplateKeyDirective],
  templateUrl: './cpt-templates.component.html'
})
export class CptTemplatesComponent {
  constructor(
    public transifexService: TransifexService,
    public sharedTranslationsService: SharedTranslationsService
  ) {}
}
